// A titled card that renders a Section<T> from the API: data, or the error with Try again.
import React from 'react';
import type { Section as ApiSection } from '../../../shared/types';
import { GAsyncState, GCard, GEyebrow, GH2 } from './atoms';

export function SectionCard<T>({ title, hint, right, section, loading, onRetry, children }: {
  title: string; hint?: React.ReactNode; right?: React.ReactNode;
  section: ApiSection<T> | undefined; loading?: boolean; onRetry: () => void;
  children: (data: T) => React.ReactNode;
}) {
  return (
    <GCard style={{ marginBottom: 18 }} padding="18px 20px">
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 12, marginBottom: 12 }}>
        <GH2 size={17}>{title}</GH2>
        {hint && <GEyebrow style={{ fontSize: 12 }}>{hint}</GEyebrow>}
        <div style={{ flex: 1 }} />
        {right}
      </div>
      {!section ? <GAsyncState busy={!!loading} error={null} label="Loading…" />
        : section.ok ? children(section.data)
        : <GAsyncState busy={false} error={section.error} onRetry={onRetry} />}
    </GCard>
  );
}

export function Empty({ children }: { children: React.ReactNode }) {
  return <div style={{ fontFamily: 'var(--ff-code)', fontSize: 12.5, color: 'var(--fg-4)' }}>{children}</div>;
}
